'use strict';

/**
 * @extends {ngtk.model.List}
 */
ngtk.model.Collection = ngtk.model.List.extend({

    _initialize: function() {
        this._items = {};
        this._itemsScopeData = {};
    },

    _updateItemsScopeData: function() {
        angular.forEach(this._itemsScopeData, function (value, key) {
            if (angular.isUndefined(this._items[key])) {
                delete this._itemsScopeData[key];
            }
        }.bind(this));

        this.forEach(function(item, key) {
            this._itemsScopeData[key] = item.exportData();
            this._itemsScopeData[key].$model = item;
        }.bind(this));
    },

    _wireScope: function(scope, scopeInnerPtr, scopeInnerElement) {
        scopeInnerPtr[scopeInnerElement] = this._itemsScopeData;
        scopeInnerPtr[scopeInnerElement].$model = this;
    }

});